import React from 'react';
import PropTypes from 'prop-types';
import { lessonTypeLabel, lessonTimeLabel, polishDate } from './clientPortalSelectors';
import { BillingSummary, PackageCard, AssociationNotice } from './PortalCards';
import { useTranslation } from 'react-i18next';

export default function ClientDashboard({ data, client, hasStudents, lessonTypes, renderLesson, link }) {
  const { t: tr, i18n } = useTranslation();
  return (
    <>
      {!hasStudents && <p className="client-portal__card">{tr("client:noAssignedStudents_0")}</p>}
      <div className={`client-portal__summary-grid${hasStudents ? '' : ' client-portal__summary-grid--payer'}`}>
        {hasStudents && (
        <section className="client-portal__card client-portal__nearest"><h2>{tr("client:nextLesson_1")}</h2>
          {data.nearest ? renderLesson(data.nearest) : <p>{tr("client:noUpcomingLessonsThatHaveNotBeenCancelled_2")}</p>}
        </section>
        )}
        <div><BillingSummary ledger={data.ledger} client={client} />{link('billing', tr("client:goToSettlements_3"))}</div>
      </div>
      {hasStudents && (
      <section className="client-portal__card"><div className="client-portal__section-heading"><h2>{tr("client:schedule_4")}</h2>{link('schedule', tr("manage:extraViewSchedule_89"))}</div>
        {data.schedulePreview.map(lesson => (
          <article className="client-portal__schedule-preview" key={`${lesson.lessonId}-${lesson.studentId}`}>
            <strong>{polishDate(lesson.date, false, i18n.language)}</strong><span>{lessonTimeLabel(lesson, lessonTypes, i18n.language)}</span><span>{lesson.studentName}</span>
            <span>{lessonTypeLabel(lesson.classTypeId, lessonTypes, i18n.language)}</span>
            {lesson.lessonStatus === 'cancelled' && <span>{tr("manage:lessonCancelled_54")}</span>}
            {lesson.lessonStatus !== 'cancelled' && String(lesson.participationStatus).startsWith('cancelled') && <span>{tr("client:participationCancelled_5")}</span>}
          </article>
        ))}
        {!data.schedule.length && <p>{tr("client:noUpcomingLessons_6")}</p>}
      </section>
      )}
      {hasStudents && (
      <section className="client-portal__card"><div className="client-portal__section-heading"><h2>{tr("manage:packages_327")}</h2>{link('packages', tr("manage:extraAllPackages_90"))}</div>
        {data.unknownAssociations.packages && <AssociationNotice />}
        {data.packagePreview.map(item => <PackageCard key={item.id} item={item} lessonTypes={lessonTypes} />)}
        {!data.packages.length && !data.unknownAssociations.packages && <p>{tr("client:noPackages_7")}</p>}
      </section>
      )}
    </>
  );
}
ClientDashboard.propTypes = {
  data: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  hasStudents: PropTypes.bool.isRequired,
  lessonTypes: PropTypes.array.isRequired,
  renderLesson: PropTypes.func.isRequired,
  link: PropTypes.func.isRequired,
};
